import { FC, useEffect } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import EfImg from 'elem/ui/ef-img';

interface IProps {
    isFormPage?: boolean;
}

const Conditions: FC<IProps> = ({ isFormPage }) => {
    const { locale } = getLocal();
    const { t } = useLang('tradein');

    return (
        <div className={styled.Conditions} id="trade-in-tc">
            <div className="tradein-spaec"></div>
            <div className={`${isFormPage ? 'conditions-form' : 'ef-container conditions-content'}`}>
                <p className="title">Terms & Conditions</p>
                <p className="section">Eligibility of Participants</p>
                <p>You must be at least the age of majority to be eligible to trade in for an EcoFlow Gift Card.</p>
                <p className="section">EcoFlow Trade-In</p>
                <p>
                    [1] Trade-in values will vary based on the condition and configuration of your eligible trade-in device. Not all devices are eligible for
                    trade in. Trade-in devices are currently limited to the choices provided by the evaluation form. Actual value awarded is based on receipt of
                    a qualifying device matching the description provided when estimate was made. You don&apos;t need to return River Max/River Plus/River Max
                    Plus/River mini wireless/River mini/Delta 1000/Delta mini/WAVE 1 in the EcoFlow Trade-In program.
                </p>
                <p>[2] You don&apos;t need to return devices from other brands in the EcoFlow Trade-In program.</p>
                <p>[3] You must remove all data, including all confidential and personal data, from your trade-in device before returning it to EcoFlow.</p>
                <p>
                    [4] Please note: Once you have chosen to return devices and submit the trade-in evaluation form, the decision cannot be revoked and the
                    warranty on the devices will expire immediately.
                </p>
                <p>[5] Refurbished products cannot be traded in.</p>
                <p>
                    [6] In the event of fraudulent & cheating situations, EcoFlow reserves the right to withdraw or not issue the Gift Card. Fraudulent &
                    cheating situations include, but are not limited to:
                </p>
                <p>- The devices received by EcoFlow are not as you described.</p>
                <p>- Duplicate applications for EcoFlow trade-in.</p>
                <p>- After purchasing a new EcoFlow product, apply for EcoFlow trade-in and then make a return and refund request.</p>
                <p>[7]. EcoFlow reserves the final explanation right of the activity.</p>
                <p className="section">EcoFlow Gift Card</p>
                <p>- We will review the trade-in evaluation form within 2 working days.</p>
                <p>
                    - We will send the Gift Card via your registered email after our approval of receiving the devices or verifying your receipt, product S/N
                    and proof of purchase.
                </p>
                <p>- The EcoFlow Gift Card is non-transferable, non-exchangeable and non-refundable for cash.</p>
                <p>
                    - The EcoFlow Gift Card can be applied on&nbsp;
                    <a href={`https://${locale}.ecoflow.com`} target="_blank" rel="noreferrer">
                        {`${locale}.ecoflow.com`}
                    </a>
                    &nbsp; only to all products at any time.
                </p>
                <p>- The Gift Card can be stacked and used with a single coupon code (please note that coupon codes cannot be stacked).</p>
                <p>- If the Gift Card is applied with your order, the value of the Gift Card will not be refunded when you cancel or refund the order.</p>
                <p>
                    - The Gift Card can only be used for purchases that have not yet been made and cannot be used to refund the price difference on orders that
                    have already been purchased.
                </p>
            </div>
            <div className="tradein-spaec"></div>
        </div>
    );
};

export default Conditions;
